export default "__VITE_ASSET__DCz43ymQ__"